import styled from "styled-components";
import mixins from "../../../styles/mixins";

const Wrap = styled.section`
    justify-content: flex-start !important;
    height: 152px;

    &.direction-row {
        .h4 {
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
        }
    }

    .h4 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px 0;
        white-space: nowrap;
        margin-bottom: 8px;

        &.direction-column {
            justify-content: flex-start;
        }

        & + .h1 {
            flex-grow: 1;
        }
    }

    .level-cont {
        max-width: 523px;
    }

    .ribbon-graph + .text-cont {
        min-height: ${mixins.clampTextLine(props => props.line == 1 ? "18px" : "34px")};
        color: #000;
        ${mixins.body3};
        line-height: 16.8px;
        margin-top: 10px;
        width: 100%;
        ${mixins.clampTextLine(props => {
            return props.line
        })}
    }

    .ribbon-graph {
        height: 20px;
        &.has-tooltip {
            margin-top: 37px;
        }
    }
`;
export default function DegreeSection({type, items=[], text, line=3, direction, badge, levelFloat, ...props}) {
    let fillGraph = true;
    return (
        <Wrap className={direction == "row" ? "direction-row" : ""} line={line} style={{height: props.height ? props.height : ""}}>
            <div className="h4">
                {type} 정도
                <div className="report-badge">{badge}</div>
            </div>

            <div className="w-100">

                <div className={levelFloat != undefined ? "ribbon-graph level has-tooltip" : "ribbon-graph level"}>
                    {
                        items.map((el, idx) => {
                            let showTooltip = false;
                            if (el.label) {
                                if (parseInt(el.label) == parseInt(levelFloat)) {
                                    showTooltip = true;
                                }
                            }
                            const returnJsx = <div key={idx} className={fillGraph ? "fill" : ""}>
                                                {el.label ? el.label : el.value}
                                                {
                                                showTooltip &&
                                                <div className="tooltip">
                                                    <span>{levelFloat}</span>레벨
                                                </div>
                                                }
                                            </div>
                            if (levelFloat != undefined) {
                                if (parseInt(el.label) == parseInt(levelFloat)) {
                                    fillGraph = false;
                                }
                            } else {
                                if (badge == el.value) {
                                    fillGraph = false;
                                }
                            }
                            return returnJsx;
                        })
                    }
                </div>

                <div className="text-cont">{text}</div>
            </div>
        </Wrap>
    )
}